import { ActionTree, MutationTree, GetterTree } from 'vuex';

import { StaffApi } from '@/api/StaffApi';

const state = {
   agents: [],
   drivers: [],
   guides: [],
   services: [],
};

const mutations: MutationTree<any> = {
   SET_ITEMS(state, { type, items }) {
      state[type] = items;
   },
};

const getters: GetterTree<any, any> = {};

const actions: ActionTree<any, any> = {
   SET_GUIDES({ commit }) {
      return StaffApi.guides().then(resp => {
         commit('SET_ITEMS', { type: 'guides', items: resp });
         return resp.length;
      });
   },
   SET_AGENTS({ commit }) {
      return StaffApi.agents().then(resp => {
         commit('SET_ITEMS', { type: 'agents', items: resp });
         return resp.length;
      });
   },
   SET_DRIVERS({ commit }) {
      return StaffApi.drivers().then(resp => {
         commit('SET_ITEMS', { type: 'drivers', items: resp });
         return resp.length;
      });
   },
   SET_SERVICES({ commit }) {
      return StaffApi.services().then(resp => {
         commit('SET_ITEMS', { type: 'services', items: resp });
         return resp.length;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
